import { Col, Row } from "react-bootstrap";
import { WfsParametersV2 } from "../../../types/Wfs/WfsParametersV2";
import { useMemo } from "react";
import PublicTransportModes from "../../../constant/PublicTransportModes";

export interface PublicTransportFiltersProps {
  wfsParameters: WfsParametersV2;
}

const PublicTransportFilters = ({
  wfsParameters,
}: PublicTransportFiltersProps) => {
  const { importQuarter, modes } = useMemo(() => {
    let importQuarter: string | undefined = undefined;
    let modes: string[] = [];
    if (wfsParameters.filter) {
      const iqPattern = new RegExp(/ImportQuarter\s+=\s+"(\d{4}\sQ\d)"/, "i");
      const iqMatch = iqPattern.exec(wfsParameters.filter);
      const modesPattern = new RegExp(
        /RouteType\s+in\s+(\d+(?:,\s*\d+)*)/,
        "i",
      );
      const modesMatch = modesPattern.exec(wfsParameters.filter);

      if (iqMatch) {
        importQuarter = iqMatch[1];
      }

      if (modesMatch) {
        let modesList = modesMatch[1];
        modesList.replace(" ", "");
        modes = modesList
          .split(",")
          .map(
            (id) =>
              PublicTransportModes.find((m) => m.id === parseInt(id))?.label,
          )
          .filter((x) => x !== undefined) as string[];
      }
    }
    return { importQuarter: importQuarter, modes: modes };
  }, [wfsParameters.filter]);

  return (
    <>
      <Row>
        <Col md="3">Import Quarter</Col>
        <Col md="9">{importQuarter}</Col>
      </Row>
      <Row>
        <Col md="3">Modes</Col>
        <Col md="9">
          {modes.length === 0
            ? "All"
            : modes.map((mode) => (
                <>
                  {mode} <br />
                </>
              ))}
        </Col>
      </Row>
    </>
  );
};

export default PublicTransportFilters;
